export const ActionTypes = {
    SET_MOVIES: "SET_MOVIES",
    SELECTED_MOVIE: "SELECTED_MOVIES",
    REMOVE_SELECTED_MOVIE: "REMOVE_SELECTED_MOVIE",
    SET_FEATURED_MOVIES: "SET_FEATURED_MOVIES",
    SET_MAIN_MOVIES: "SET_MAIN_MOVIES",
    SET_HERO_MOVIE: "SET_HERO_MOVIE",
    ADD_TO_WATCHLIST: "ADD_TO_WATCHLIST",
    REMOVE_FROM_WATCHLIST: "REMOVE_FROM_WATCHLIST",
    BADGE_TRUE: "BADGE_TRUE"
} 